import style from './FilterIcon.module.scss'
import { useDispatch, useSelector } from 'react-redux'
import FilterIcon from '@mui/icons-material/Filter';
import { red } from '@mui/material/colors';
import { setFilter } from '../../../redux/headerSlices/HeaderSlices';
import { selectHeader } from '../../../redux/headerSlices/HeaderSelector'

let FilterIcons = () => {

    const dispatch = useDispatch()

    const { filter } = useSelector(selectHeader)

    return (
        <div className={style.profile__filter}>
            {filter ?
                <FilterIcon sx={{ fontSize: 40, color: red[700] }} onClick={e => dispatch(setFilter(!filter))} data-testid='toggle-element' />
                :
                <FilterIcon sx={{ fontSize: 40 }} onClick={e => dispatch(setFilter(!filter))} />
            }
        </div>
    )
}

export default FilterIcons;